import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { WebSocketService } from '@qtek/core/websockets-core';
import { filter, map, switchMap, takeUntil, tap } from 'rxjs';
import { SchemaEditorActions } from './schemas.actions';
import { SchemasService } from './schemas.service';

@Injectable()
export class SchemasEditorEffects {
  connectDocs$ = createEffect(() =>
    this.actions$.pipe(
      ofType(SchemaEditorActions.connectSchemas),
      switchMap(({ mysid }: { mysid: string }) =>
        this.schemasService
          .subscribe({ mysid })
          .pipe(
            takeUntil(
              this.actions$.pipe(ofType(SchemaEditorActions.disconnectSchemas))
            )
          )
      ),
      map(({ op, res, sts }: any) => {
        switch (op) {
          case 'query':
            return res
              ? SchemaEditorActions.getSchemasSuccess({ schemas: res })
              : SchemaEditorActions.getSchemasFailure();

          case 'upd':
            return res
              ? SchemaEditorActions.updateSchemaSuccess({ schema: res })
              : SchemaEditorActions.updateSchemaFailure({ error: sts });
          default:
            return {
              type: '[Schema] Unknown operation',
            };
        }
      })
    )
  );

  updateSchema$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(SchemaEditorActions.updateSchema),
        tap(({ payload }) => {
          this.schemasService.updateAttribute(payload);
        })
      ),
    { dispatch: false }
  );

  getSchema$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(SchemaEditorActions.getSchema),
        tap(({ sid }) => this.schemasService.getSchema(sid))
      ),
    { dispatch: false }
  );

  getSchemaListener$ = createEffect(() =>
    this.webSocketService.getWebSocketIsAlive$().pipe(
      filter(Boolean),
      switchMap(() => this.webSocketService.getWebSocketSubject()),
      switchMap(socket =>
        socket
          .asObservable()
          .pipe(
            filter(message => message.op === 'get' && message.ent === 'sma')
          )
      ),
      map(({ op, res, sts }: any) => {
        return res
          ? SchemaEditorActions.getSchemaSuccess({
              schema: res,
            })
          : SchemaEditorActions.getSchemaFailure({ error: sts });
      })
    )
  );
  constructor(
    private actions$: Actions,
    private schemasService: SchemasService,
    private webSocketService: WebSocketService
  ) {}
}
